import { Box, Skeleton } from '@mui/material';

const DeviceCardSkeleton = () => {
    return (
        <Box
            sx={{
                p: 1.25,
                borderRadius: 2,
                bgcolor: '#FFFFFF',
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.25,
                }}
            >
                <Skeleton variant="text" width={40} height={20} />
                <Skeleton variant="rounded" width={92} height={24} sx={{ borderRadius: 999 }} />
            </Box>

            <Skeleton variant="text" width="86%" height={28} sx={{ mt: 0.75 }} />

            <Box sx={{ mt: 0.75 }}>
                <Skeleton variant="text" width={76} height={16} />
                <Skeleton variant="text" width="68%" height={20} />
            </Box>

            <Box
                sx={{
                    mt: 0.75,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.25,
                }}
            >
                <Skeleton variant="text" width={90} height={18} />
                <Skeleton variant="text" width={104} height={18} />
            </Box>
        </Box>
    );
};

const RegisterDeviceSkeleton = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                minHeight: 0,
                bgcolor: '#F8FAFC',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    px: 1.5,
                    py: 1,
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        height: 48,
                        borderRadius: '12px',
                        bgcolor: '#FFFFFF',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        alignItems: 'center',
                        px: 1.5,
                    }}
                >
                    <Skeleton variant="text" width="42%" height={22} />
                    <Skeleton
                        variant="rounded"
                        width={48}
                        height={24}
                        sx={{
                            ml: 'auto',
                            borderRadius: 999,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        height: 68,
                        borderRadius: '12px',
                        bgcolor: '#FFFFFF',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        alignItems: 'center',
                        px: 1.5,
                    }}
                >
                    <Skeleton variant="circular" width={25} height={25} />
                    <Skeleton variant="rounded" sx={{ flex: 1, mx: 1.5 }} height={4} />
                    <Skeleton variant="circular" width={25} height={25} />
                    <Skeleton variant="rounded" sx={{ flex: 1, mx: 1.5 }} height={4} />
                    <Skeleton variant="circular" width={25} height={25} />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        sx={{
                            flex: 1,
                            borderRadius: '12px',
                        }}
                        height={42}
                    />
                    <Skeleton variant="rounded" width={42} height={42} sx={{ borderRadius: '12px' }} />
                    <Skeleton variant="rounded" width={42} height={42} sx={{ borderRadius: '12px' }} />
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        {Array.from({ length: 4 }).map((_, index) => (
                            <DeviceCardSkeleton key={index} />
                        ))}
                    </Box>
                </Box>
            </Box>

            <Box
                sx={{
                    flexShrink: 0,
                    bgcolor: '#FFFFFF',
                    borderTop: '1px solid #E5E7EB',
                    p: 1.5,
                    pb: 'calc(12px + env(safe-area-inset-bottom))',
                }}
            >
                <Skeleton variant="text" width="100%" height={22} sx={{ mx: 'auto', mb: 1 }} />
                <Skeleton variant="rounded" width="100%" height={44} sx={{ borderRadius: 2 }} />
            </Box>
        </Box>
    );
};

export default RegisterDeviceSkeleton;
